export enum FormatType {
  YMD = "yyyy-MM-dd",
  YMDHM = "yyyy-MM-dd HH:mm",
}
export const dateFormatter = (
  value: number | string,
  formatter?: string | FormatType
) => {
  if (value !== null && value !== undefined && value !== "") {
    if (value === 0) {
      return "——";
    }
    const date = new Date(value);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hour = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const seconds = ("0" + date.getSeconds()).slice(-2);

    switch (formatter) {
      case "yyyy-MM-dd":
        return `${date.getFullYear()}-${month}-${day}`;
      case "yyyy-MM-dd HH:mm":
        return `${date.getFullYear()}-${month}-${day} ${hour}:${minutes}`;
      default:
        return `${date.getFullYear()}-${month}-${day} ${hour}:${minutes}:${seconds}`;
    }
  }
  return "";
};
